<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <ValidationObserver ref="formObserver" v-slot="{ validate }">
                    <b-form @submit.prevent="handleSubmit(validate)">
                      <div class="form-row">
                        <!-- CENTERS -->
                        <div class="form-group col-md-4">
                          <ValidationProvider name="Centrals" rules="required" v-slot="{ errors }">
                            <label for="center_id">
                              <span class="required">*</span> {{ $t('Centrals') }} :
                            </label>
                            <v-select
                                :options="centers"
                                :reduce="center => center.id"
                                :label="'name'"
                                v-model="vehicle_ipva.center_id"
                                class="vselect"
                                @input="changetUnitsCenter"
                                :class="{ 'is-invalid': errors.length }"
                            />
                            <span class="invalid-feedback">{{ $t(errors[0]) }}</span>
                          </ValidationProvider>
                        </div>

                        <!-- UNITS -->
                        <div class="form-group col-md-4">
                          <ValidationProvider name="Unit" rules="required" v-slot="{ errors }">
                            <label for="unit_id">
                              <span class="required">*</span> {{ $t('Unit') }} :
                            </label>
                            <v-select
                                :options="units"
                                :reduce="unit => unit.id"
                                :label="'name'"
                                v-model="vehicle_ipva.unit_id"
                                class="vselect"
                                @input="changeVehicleByUnits"
                                :class="{ 'is-invalid': errors.length }"
                            />
                            <span class="invalid-feedback">{{ $t(errors[0]) }}</span>
                          </ValidationProvider>
                        </div>

                        <!-- VEHICLES -->
                        <div class="form-group col-md-4">
                          <ValidationProvider name="Vehicle" rules="required" v-slot="{ errors }">
                            <label for="vehicle_id">
                              <span class="required">*</span> {{ $t('Vehicle') }} :
                            </label>
                            <v-select
                                :options="vehicles"
                                :reduce="vehicle => vehicle.id"
                                :label="'name'"
                                v-model="vehicle_ipva.vehicle_id"
                                class="vselect"
                                :class="{ 'is-invalid': errors.length }"
                            />
                            <span class="invalid-feedback">{{ $t(errors[0]) }}</span>
                          </ValidationProvider>
                        </div>

                        <!-- PAYMENT DATE -->
                        <div class="form-group col-md-4">
                          <ValidationProvider name="Payment date" rules="required" v-slot="{ errors }">
                            <label for="payment_date">
                              <span class="required">*</span> {{ $t('Payment date') }} :
                            </label>
                            <b-form-input
                                autocomplete="new-password"
                                type="date"
                                id="payment_date"
                                class="form-control"
                                v-model="vehicle_ipva.payment_date"
                                :state="errors.length ? false : null"
                            />
                            <b-form-invalid-feedback>{{ $t(errors[0]) }}</b-form-invalid-feedback>
                          </ValidationProvider>
                        </div>

                        <!-- IPVA VALUE -->
                        <div class="form-group col-md-4">
                          <ValidationProvider name="Ipva value" rules="required" v-slot="{ errors }">
                            <label for="ipva_value">
                              <span class="required">*</span> {{ $t('Ipva value') }} :
                            </label>
                            <money
                                id="value"
                                v-model="vehicle_ipva.ipva_value"
                                v-bind="money"
                                class="form-control"
                                :class="{ 'is-invalid': errors.length }"
                                @change="onIpvaValueChange"
                            />
                            <span class="invalid-feedback">{{ $t(errors[0]) }}</span>
                          </ValidationProvider>
                        </div>

                        <div class="form-group col-md-4" v-if="vehicle_ipva.ipva_value > 0">
                          <ValidationProvider
                              name="Number of Installments"
                              rules="required"
                              v-slot="{ errors }"
                          >
                            <label for="installment_total">
                              <span class="required">*</span> {{ $t('Number of Installments') }} :
                            </label>
                            <b-form-select
                                id="installment_total"
                                :options="installmentOptions"
                                v-model.number="installment_total"
                                @change="onInstallmentTotalChange"
                                :class="{ 'is-invalid': errors.length }"
                            />
                            <span class="invalid-feedback">{{ $t(errors[0]) }}</span>
                          </ValidationProvider>
                        </div>

                        <div class="form-group col-md-13" v-if="vehicle_ipva.ipva_value > 0 && installments.length > 0">
                          <div class="row">
                            <div class="form-group col-md-4" v-for="(installment, index) in installments"
                                 :key="'value_' + index">
                              <label>{{ $t('Installment') }} #{{ index + 1 }}</label>
                              <money
                                  :value="installment.value"
                                  @input="val => updateInstallmentValue(index, val)"
                                  v-bind="money"
                                  class="form-control"
                                  readonly
                              />
                            </div>

                            <div class="form-group col-md-7" v-for="(installment, index) in installments"
                                 :key="'file_' + index">
                              <span class="required">*</span>
                              <label>{{ $t('Attach file for installment') }} #{{ index + 1 }}</label>
                              <ValidationProvider :name="`file_${index}`" v-slot="{ errors }">
                                <upload-file
                                    :file-id="installment.file_id"
                                    :existing-file="installment.upload_file"
                                    @uploaded="fileId => onFileUploaded(fileId, index)"
                                    :class="{ 'is-invalid': errors.length }"
                                    :showButtons="false"
                                />
                                <span class="invalid-feedback" v-if="errors.length">*{{ $t(errors[0]) }}</span>
                              </ValidationProvider>
                            </div>

                          </div>
                        </div>

                        <!-- DESCRIPTION -->
                        <div class="form-group col-md-12">
                          <ValidationProvider name="Description" rules="required" v-slot="{ errors }">
                            <label for="description">
                              <span class="required">*</span> {{ $t('Description') }} :
                            </label>
                            <b-form-textarea
                                class="form-control"
                                id="description"
                                v-model="vehicle_ipva.description"
                                cols="30"
                                rows="10"
                                :state="errors.length ? false : null"
                            ></b-form-textarea>
                            <b-form-invalid-feedback>{{ $t(errors[0]) }}</b-form-invalid-feedback>
                          </ValidationProvider>
                        </div>

                        <!-- REQUESTER -->
                        <div class="form-group col-md-6">
                          <ValidationProvider name="Requester" rules="required" v-slot="{ errors }">
                            <label for="requester_id">
                              <span class="required">*</span> {{ $t('Requester') }} :
                            </label>
                            <v-select
                                :options="professionals"
                                :reduce="professional => professional.id"
                                :label="'name'"
                                v-model="vehicle_ipva.requester_id"
                                class="vselect"
                                :class="{ 'is-invalid': errors.length }"
                            />
                            <span class="invalid-feedback">{{ $t(errors[0]) }}</span>
                          </ValidationProvider>
                        </div>
                      </div>
                      <span class="required_fields">
                        <span class="required">*</span>
                        <strong>{{ $t('Required Fields') }}</strong>
                      </span>
                      <div class="block text-right">
                        <b-button variant="outline-secondary" class="btn btn-back" @click="$router.go(-1)">
                          <i class="fa fa-arrow-left"></i> {{ $t('To Go Back') }}
                        </b-button>

                        <b-button type="submit" variant="primary" class="ml-1">
                          {{ $t('Save') }}
                          <i class="fa fa-save"></i>
                        </b-button>
                      </div>
                    </b-form>
                  </ValidationObserver>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {ValidationObserver, ValidationProvider, extend} from "vee-validate";
import {required, numeric, min_value, max_value} from "vee-validate/dist/rules";
import {
  BForm,
  BFormGroup,
  BFormInput,
  BFormTextarea,
  BFormSelect,
  BFormInvalidFeedback,
  BButton,
} from "bootstrap-vue";
import vSelect from "vue-select";
import UploadFile from "../../layouts/components/UploadFile";
import axios from "axios";

// Regras vee-validate
extend("required", required);
extend("numeric", numeric);
extend("min_value", min_value);
extend("max_value", max_value);

export default {
  data() {
    return {
      vehicle_ipva: {
        center_id: null,
        unit_id: null,
        vehicle_id: null,
        ipva_value: 0,
        payment_date: "",
        requester_id: null,
        description: "",
        id: null,
      },
      installment_total: null,
      installments: [],
      installmentOptions: [
        {value: null, text: "Selecione"},
        {value: 1, text: "1"},
        {value: 2, text: "2"},
        {value: 3, text: "3"},
        {value: 4, text: "4"},
        {value: 5, text: "5"},
      ],
      centers: [],
      units: [],
      vehicles: [],
      professionals: [],
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        precision: 2,
      },
    };
  },
  methods: {
    async handleSubmit(validate) {
      const isValid = await validate();
      if (isValid) {
        this.save();
      }
    },
    updateInstallmentValue(index, value) {
      if (this.installments[index]) {
        this.$set(this.installments[index], 'value', value);
      }
    },
    save() {
      let api = this.$store.state.api + "vehicle_ipvas";
      const payload = {
        ...this.vehicle_ipva,
        installments: this.installments.map((inst, idx) => ({
          ...inst,
          installment_number: inst.installment_number || (idx + 1),
          installment_total: this.installment_total,
        })),
      };

      if (this.vehicle_ipva.id) {
        payload._method = "PUT";
        api += "/" + this.vehicle_ipva.id;
      }

      axios.post(api, payload)
          .then(() => {
            this.$message(
                this.$t('Success'),
                this.$t('Information saved successfully'),
                "success"
            );
            this.$router.push("/vehicle_ipvas");
          })
          .catch(error => {
            this.$error(error);
          });
    },
    onFileUploaded(fileId, index) {
      if (this.installments[index]) {
        this.$set(this.installments, index, {
          ...this.installments[index],
          file_id: fileId,
        });
      }
    },

    changetUnitsCenter(center_id) {
      this.vehicle_ipva.unit_id = null;
      this.getUnitsCenter(center_id);
    },

    changeVehicleByUnits(unit_id) {
      this.vehicle_ipva.vehicle_id = null;
      this.getVehicles(unit_id);
    },

    generateInstallments() {
      const total = Number(this.installment_total);
      const baseValue = Number(this.vehicle_ipva.ipva_value) || 0;

      if (!total || total < 1 || baseValue <= 0) {
        this.installments = [];
        return;
      }

      const totalCents = Math.round(baseValue * 100);
      const baseInstallmentCents = Math.floor(totalCents / total);
      const remainder = totalCents - baseInstallmentCents * total;

      const newInstallments = [];

      for (let i = 0; i < total; i++) {
        let installmentCents = baseInstallmentCents;
        if (i === total - 1) {
          installmentCents += remainder;
        }

        const old = this.installments[i] || {};

        const value = Number((installmentCents / 100).toFixed(2));

        newInstallments.push({
          installment_number: i + 1,
          installment_total: total,
          value,
          file: old.file || null,
          file_id: old.file_id || null,
          upload_file: old.upload_file || null,
        });
      }

      this.installments = [...newInstallments];
    },

    onIpvaValueChange() {
      const raw = this.vehicle_ipva.ipva_value;

      if (typeof raw === "string") {
        const numeric = parseFloat(
            raw.replace("R$", "").replace(/\./g, "").replace(",", ".")
        );
        this.vehicle_ipva.ipva_value = isNaN(numeric) ? 0 : numeric;
      }

      if (this.vehicle_ipva.ipva_value > 0 && this.installment_total) {
        this.generateInstallments();
      }
    },

    onInstallmentTotalChange() {

      const totalValue = parseFloat(this.vehicle_ipva.ipva_value || 0);
      if (!totalValue || this.installment_total <= 0) {
        return;
      }

      const baseValue = (totalValue / this.installment_total).toFixed(2);
      const base = parseFloat(baseValue);
      const remainder = +(totalValue - base * this.installment_total).toFixed(2);

      const updatedInstallments = Array.from({length: this.installment_total}, (_, i) => {
        const value = i === 0 ? (base + remainder).toFixed(2) : base.toFixed(2);

        return {
          installment_number: i + 1,
          installment_value: value,
          file: null,
        };
      });

      this.$set(this.vehicle_ipva, 'installments', updatedInstallments);
    },

    getVehicleIpva(id) {
      axios.get(`${this.$store.state.api}vehicle_ipvas/${id}`)
          .then(response => {
            const data = response.data;

            this.vehicle_ipva = {
              center_id: data.center_id,
              unit_id: data.unit_id,
              vehicle_id: data.vehicle_id,
              ipva_value: Number(data.ipva_value),
              payment_date: data.payment_date,
              requester_id: data.requester_id,
              description: data.description,
              id: data.id,
            };

            this.installment_total = data.installments ? data.installments.length : 1;
            if (data.installments && data.installments.length) {
              this.installments = data.installments.map(i => ({
                id: i.id,
                value: Number(i.value),
                file_id: null,
                upload_file: i.upload_file,
                installment_number: i.installment_number,
                installment_total: i.installment_total,
              }));

              this.$nextTick(() => {
                this.installments.forEach((inst, idx) => {
                  this.$set(this.installments[idx], 'file_id', data.installments[idx].file_id);
                });
              });
            } else {
              this.generateInstallments();
            }

            if (this.vehicle_ipva.center_id) this.getUnitsCenter(this.vehicle_ipva.center_id);
            if (this.vehicle_ipva.unit_id) this.getVehicles(this.vehicle_ipva.unit_id);

          }).catch(error => {
        this.$error(error);
      });
    },
    getCenters() {
      const api = `${this.$store.state.api}centers/`;
      axios
          .get(api)
          .then((response) => {
            this.centers = response.data.data;
          })
          .catch((error) => {
            this.$error(error);
          });
    },

    getUnitsCenter(center_id) {
      const api = `${this.$store.state.api}centers/unit/${center_id}`;
      axios
          .get(api)
          .then((response) => {
            this.units = response.data;
          })
          .catch((error) => {
            this.$error(error);
          });
    },

    getVehicles(unit_id) {
      const api = `${this.$store.state.api}units/vehicles/${unit_id}`;
      axios
          .get(api)
          .then((response) => {
            this.vehicles = response.data;
          })
          .catch((error) => {
            this.$error(error);
          });
    },

    getProfessionals() {
      const api = `${this.$store.state.api}professionals/`;
      axios
          .get(api)
          .then((response) => {
            this.professionals = response.data.data;
          })
          .catch((error) => {
            this.$error(error);
          });
    },
  },
  watch: {
    'vehicle_ipva.ipva_value': function (newVal) {
      if (newVal > 0 && this.installment_total) {
        this.onIpvaValueChange();
      }
    },
    installment_total(newVal) {
      this.generateInstallments(newVal);
    }
  },
  mounted() {
    const id = this.$route.params.id;

    this.getCenters();
    this.getProfessionals();

    if (id) {
      this.getVehicleIpva(id);
    } else {
      this.generateInstallments();
    }
  },
  components: {
    ValidationObserver,
    ValidationProvider,
    BForm,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BFormSelect,
    BFormInvalidFeedback,
    BButton,
    vSelect,
    UploadFile,
  },
};
</script>

<style scoped>
.required {
  color: red !important;
}

.vselect {
  width: 100%;
}

.installment-group {
  margin-bottom: 15px;
  border-bottom: 1px solid #eee;
  padding-bottom: 15px;
}
</style>
